/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

/**
 * Webpack JS chunk failures set `error.name = "ChunkLoadError"`.
 * CSS extract chunk failures are plain `Error`s whose message is
 * `Loading CSS chunk <id> failed.` — same stale-deploy class of problem,
 * different error shape.
 */
const CHUNK_LOAD_ERROR_MESSAGE = /Loading(?: CSS)? chunk [^\s]+ failed/i
const CHUNK_ERROR_NAME = "ChunkLoadError"

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") {
    return false
  }

  const { name, message } = error as { name?: string; message?: string }

  if (name === CHUNK_ERROR_NAME) {
    return true
  }

  return typeof message === "string" && CHUNK_LOAD_ERROR_MESSAGE.test(message)
}
